import { useContext, useEffect, useState } from "react";
import DashboardEnvContext from "./DashboardEnvContext";
import { CDashboardModulePage, Context, DashboardModulePageProps, InitResponse, PageActions, PageContext } from "./types";
import { Params, useParams } from "react-router-dom";
import DashboardPageContext from "./DashboardPageContext";
import ExecutionTypeContext, { Mode } from "./ExecutionTypeContext";
import { Box } from "@mui/material";
import DashboardComponent from "./components/DashboardComponent";
import CircularProgress from "@mui/material/CircularProgress";
import styled from "@emotion/styled";
import PageActionsBoundary from "./PageActionsBoundary";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const moment= require('moment');

const CircularProgressFullScreenWrapper = styled.div`
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	background: rgba(255, 255, 255, 0.4);
	z-index: 1;
`;

const CircularProgressWrapper = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 100px;
	text-align: center;
	margin-left: -50px;
`;

const LOADED_PAGES_CACH = {} as { [key: string]: CDashboardModulePage };

const DashboardModulePage: React.FC<DashboardModulePageProps> = ({ pageParam }) => {
	// eslint-disable-next-line
	const dashboard = useContext(DashboardEnvContext);
	const [context, setContext] = useState<Context>();
	const params = useParams();
	const [page, setPage] = useState<CDashboardModulePage>(pageParam);
	const [pageLoaderActive, setPageLoaderActive] = useState<boolean>(true);
	const [pageContentLoaded, setPageContentLoaded] = useState<boolean>(false);

	useEffect(() => {
		if (LOADED_PAGES_CACH[pageParam.id] == undefined) {
			async function loadPageContent() {
				if (dashboard && dashboard.axios && dashboard.variables) {
					const response = await dashboard.axios.post(`${dashboard.variables["DB_ADMIN_URL_CTRL_PREFIX"]}/backend-action/dashboard/configuration/page`, {
						pageId: page.id,
					});
					const jsonData = await response.data.data;
					setPage(jsonData);
					LOADED_PAGES_CACH[jsonData.id] = jsonData as CDashboardModulePage;
					setPageContentLoaded(true);
				}
			}
			loadPageContent();
		} else {
			setPage(LOADED_PAGES_CACH[pageParam.id]);
			setPageContentLoaded(true);
		}
	}, [dashboard]);

	useEffect(() => {
		if (pageContentLoaded) {
			async function prepare() {
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				const initContext = (await await eval("async () => {" + page.initScript + "}")()) as InitResponse;
				initContext.page.__CONTEXT_VERSION = 0;
				setContext(initContext.page as PageContext);
				setPageLoaderActive(false);
			}
			prepare();
		}
	}, [pageContentLoaded]);

	const updateContext = (newValue: Context) => {
		if ((context?.__CONTEXT_VERSION as number) < (newValue.__CONTEXT_VERSION as number)) {
			alert("CONTEXT OVERRIDEN TRIAL!");
			return newValue;
		}
		newValue.__CONTEXT_VERSION = (newValue.__CONTEXT_VERSION as number) + 1;
		setContext(JSON.parse(JSON.stringify(newValue)));
		return newValue;
	};

	return (
		<>
			{dashboard && params && page && page.content && (
				<>
					<DashboardPageContext.Provider value={{ context: context, params, updateContext, activatePageLoader: (status: boolean) => setPageLoaderActive(status) } as PageContext}>
						<ExecutionTypeContext.Provider value={{ mode: Mode.RUNTIME, locatorActivated: false }}>
							<PageActionsBoundary actions={page.pageActions}>
								<Box sx={{ flex: 1, position: "relative", display: "flex" }}>
									{pageLoaderActive && (
										<CircularProgressFullScreenWrapper>
											<CircularProgressWrapper>
												<CircularProgress />
											</CircularProgressWrapper>
										</CircularProgressFullScreenWrapper>
									)}
									{context && <DashboardComponent component={page.content} />}
								</Box>
							</PageActionsBoundary>
						</ExecutionTypeContext.Provider>
					</DashboardPageContext.Provider>
				</>
			)}
		</>
	);
};

export default DashboardModulePage;
